module.exports = __webpack_public_path__ + "assets/img/bluebird-og-image.a8ca7a96.webp";